import { render, staticRenderFns } from "./ProjectApps.vue?vue&type=template&id=3986a2e3&scoped=true"
import script from "./ProjectApps.vue?vue&type=script&lang=js"
export * from "./ProjectApps.vue?vue&type=script&lang=js"
import style0 from "./ProjectApps.vue?vue&type=style&index=0&id=3986a2e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986a2e3",
  null
  
)

export default component.exports